import Component from '../core/Component'
import Scroll from '../services/Scroll'
import enquire from 'enquire.js'
import { queries } from '../core/config'

const STATES = {
    COLLAPSED: 'is-collapsed',
    EXPANDED: 'is-expanded',
    SEARCH_ACTIVE: 'is-search-active',
    DISABLED: 'is-disabled',
    FOCUSED: 'is-focused'
}

export default class SearchForm extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            searchToggle: null,
            searchForm: null,
            searchCloseBtn: null,
            input: null
        }

        this.enquireHandler = {
            match: () => {
                this.ref.searchForm.removeAttribute('style')
            }
        }
        this.isSearchPage = false
    }

    prepare() {
        if (this.isSearchPage) {
            const input = searchForm.querySelector('input')
            input?.focus()
        }
        if (this.ref.searchToggle) {
            this.ref.searchToggle.addEventListener('click', this.handleSearchToggleClick)
        }
        if (this.ref.searchCloseBtn) {
            this.ref.searchCloseBtn.addEventListener('click', this.handleSearchCloseClick)
        }
        if (this.ref.input) {
            this.ref.input.addEventListener('focus', this.handleInputFocus)
            this.ref.input.addEventListener('blur', this.handleInputBlur)
        }
        this.isSearchPage = document.getElementsByTagName('body')[0].classList.contains('search-Page')

        Scroll.on('resize', this.handleResize)
        enquire.register(queries.smallWideMax, this.enquireHandler)
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
        enquire.unregister(queries.smallWideMax, this.enquireHandler)
    }

    handleResize = () => {
        this.resize()
    }

    handleInputFocus = event => {
        event.preventDefault()
        event.target.value = ''
        event.target.setAttribute('placeholder', '')
        event.target.parentNode.classList.add('is-focused')
    }

    handleInputBlur = event => {
        event.preventDefault()
        event.target.parentNode.classList.remove('is-focused')
    }

    handleSearchCloseClick = event => {
        event.preventDefault()
        this.hideSearch()
    }

    handleSearchToggleClick = event => {
        event.preventDefault()
        this.toggleSearch()
    }

    handleToggleClick = event => {
        event.preventDefault()
        this.toggle()
    }

    resize() {
        if (this.is(STATES.SEARCH_ACTIVE)) {
            this.element.style.height = `${this.ref.searchForm.scrollHeight}px`
        }
    }

    toggle() {
        if (this.is(STATES.COLLAPSED)) {
            this.expand()
        } else {
            this.collapse()
        }
    }

    toggleSearch() {
        if (this.is(STATES.SEARCH_ACTIVE)) {
            this.hideSearch()
        } else {
            this.showSearch()
        }
    }

    showSearch() {
        this.element.classList.add(STATES.SEARCH_ACTIVE)
        this.ref.searchForm.classList.add(STATES.SEARCH_ACTIVE)
        this.ref.searchToggle.classList.add(STATES.DISABLED)
        this.ref.searchForm.style.height = `${this.ref.searchForm.scrollHeight}px`
        this.element.style.width = '340px'
        this.ref.input.focus()
        this.emit('searchshow')
    }

    hideSearch() {
        this.element.classList.remove(STATES.SEARCH_ACTIVE)
        this.ref.searchForm.classList.remove(STATES.SEARCH_ACTIVE)
        this.ref.searchToggle.classList.remove(STATES.DISABLED)
        this.element.style.width = '26px'

        if (!this.isSearchPage) {
            this.ref.searchForm.style.height = `${this.ref.searchForm.scrollHeight}px`
        }
        this.emit('searchhide')
    }
}
